<template>
  <el-select
    :disabled = "disabled"
    filterable
    remote
    value-key="id"
    v-model="order"
    :remote-method="loadOrderList"
    placeholder="输入订单编号搜索"
    @change="onChange"
    clearable
    :style="css">
    <el-option v-for="item in orderList"
      :key="item.id"
      :label="item.code"
      :value="item"/>
  </el-select>
</template>

<script>
export default {
  name: "MerchantOrderSearch",

  props: ["id", "css", 'value', 'disabled'],

  data() {
    return {
      order: null,
      orderList: []
    };
  },

  watch: {
    id : function() {
      this.loadValue(this.id);
    },
    value : function() {
      this.loadValue( this.value );
    }
  },

  methods: {
    loadValue( _id ) {
      var _this = this;
      if ( !_id || _id == "") {
        this.order = "";
        return;
      }

      sdk.TicketOrderApi().findById({
        id : _id
      }).then((res)=>{
        _this.orderList = [];
        _this.orderList.push(res);
        _this.order = res;
      });
    },

    setValue( _val ) {
      this.order = _val;
    },

    loadOrderList( _query ) {
      var _this = this;
      sdk.TicketOrderApi().search({
        key: _query
      }).then(res => {
        if(!!res) {
          _this.orderList = res;
        }
      });
    },

    onChange( e ) {
      this.$emit('input', e.id);
      this.$emit("change", e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ticket/MerchantOrderSearch.vue